import useDashboardStatistics from "../../../hooks/useDashboardStatistics"
import { DateTime } from "luxon"
import { dbDateTimeFormat } from "../../../constants"
import Loader from "../../../components/Loader"
import ApiError from "../../../components/ApiError"

const StatCard = ({ title, value, icon, color = "primary" }) => (
  <div className="bg-white rounded-lg shadow-md p-4 flex flex-col">
    <div className="flex justify-between items-start mb-4">
      <h3 className={`text-gray-600 font-medium text-sm text-${color}`}>
        {title}
      </h3>
      <div className={`text-${color} p-2 rounded-full bg-${color}/10`}>
        <span className="material-icons text-xl">{icon}</span>
      </div>
    </div>
    <div className="flex items-end justify-between">
      <div className="flex flex-col">
        <span className={`text-3xl font-bold text-${color}`}>{value}</span>
      </div>
    </div>
  </div>
)

const DashboardStatisticsCards = ({ filters }) => {
  const from =
    filters.from || DateTime.now().startOf("day").toFormat(dbDateTimeFormat)
  const to =
    filters.to || DateTime.now().endOf("day").toFormat(dbDateTimeFormat)
  const patientIssuer = filters.patientIssuer || ""

  const { data, isLoading, error, isError } = useDashboardStatistics({
    from,
    to,
    patientIssuer,
  })

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="py-12 flex justify-center items-center gap-3">
        <Loader className="border-primary" />
        <p>Loading Statistics...</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 mb-6">
      <StatCard
        color="primary"
        icon="description"
        title="Total Orders"
        value={data?.totalOrders || 0}
      />

      <StatCard
        color="green-600"
        icon="check_circle"
        title="Processed Orders"
        value={data?.processedOrders || 0}
      />

      <StatCard
        color="red-600"
        icon="cancel"
        title="Errored Out Orders"
        value={data?.rejectedOrders || 0}
      />

      <StatCard
        color="green-600"
        icon="bar_chart"
        title="Results Generated"
        value={data?.ResultsGenerated || 0}
      />

      <StatCard
        color="red-600"
        icon="error"
        title="Results With Errors"
        value={data?.ResultsErrored || 0}
      />
      <StatCard
        color="primary"
        icon="done_all"
        title="Finalized Results"
        value={data?.ResultsFinalized || 0}
      />
    </div>
  )
}

export default DashboardStatisticsCards
